import React from "react";
import { Card } from "react-bootstrap";

export default function Profile() {
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  return (
      <div className="container-fluid p-4">
        <Card>
          <Card.Body>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="font-weight-bold">Full Name : </label>
                <p>{user.fullName || "-"}</p>
              </div>

              <div className="col-md-6 mb-3">
                <label className="font-weight-bold">Email : </label>
                <p>{user.email || "-"}</p>
              </div>

              <div className="col-md-6 mb-3">
                <label className="font-weight-bold">Role : </label>
                <p>{user.role || "-"}</p>
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
  );
}
